module.exports = __webpack_public_path__ + "img/discount.29600c17.svg";